import React, { useState } from 'react'
import { faceCareData } from 'JSON/PHARMHOUSE'
import useWindowSize from "Hooks/useWindowSize";
import { ReactSVG } from 'react-svg'

const FaceCareSection = () => {

    const [activeCategoryId, setActiveCategoryId] = useState<Number>(1)
    const [mobileActive, setMobileActive] = useState<boolean>(false)

    const { width } = useWindowSize();


    const handleActiveCategory = (id: number) => {
        if (id === activeCategoryId) {
            setMobileActive((prevState) => !prevState);
        } else {
            setActiveCategoryId(id);
            setMobileActive(true);
        }
    }

  return (
    <div className='flex justify-between gap-x-[20px]'>
        <div className={`bg-blue-100 rounded-[12px] ${width > 768 && "max-w-[360px]"} min-w-[270px] w-full min-h-[415px] py-[20px]`}>
            {faceCareData?.map(item => {
                return(
                    <div className=''>
                        <div
                            className='flex justify-between items-center cursor-pointer'
                            onClick={() => handleActiveCategory(item.id)}
                        >
                            {item.id === activeCategoryId &&
                                <ReactSVG src="/images/pharmacy/pharmaHouse/Active.svg" className={`pl-[2px]`}/>
                            }
                            <div className={`flex justify-between items-center w-full py-[12px] mx-[24px]`}>
                                <div>
                                    <h3 className={`${item.id === activeCategoryId ? "text-[#ffffff] font-bold" : "text-[#FFFFFF99] font-semibold"} hover:text-[#ffffff] duration-75`}>{item.text}</h3>
                                </div>
                                <div>
                                    <ReactSVG
                                        src="/images/pharmacy/pharmaHouse/arrowRightWhite.svg"
                                        className={`${item.id === activeCategoryId && mobileActive && width < 768 && "rotate-0 md:rotate-90"}`}
                                    />
                                </div>
                            </div>

                        </div>

                        {width < 768 && item.children.parentId === activeCategoryId && mobileActive &&
                            <section className='px-[20px]'>
                                <div className='flex flex-wrap gap-[20px] justify-center items-center bg-[#ECF1FD] py-[20px] rounded-[12px]'>
                                    {item.children.img1 && <img src={item.children.img1} alt="" className='w-[80px] h-[80px]' />}
                                    {item.children.img2 && <img src={item.children.img2} alt="" className='w-[80px] h-[80px]' />}
                                    {item.children.img3 && <img src={item.children.img3} alt="" className='w-[80px] h-[80px]' />}
                                    {item.children.img4 && <img src={item.children.img4} alt="" className='w-[80px] h-[80px]' />}
                                    {item.children.img5 && <img src={item.children.img5} alt="" className='w-[80px] h-[80px]' />}
                                </div>
                            </section>
                        }

                    </div>

                )
            })}
        </div>

        {width > 768 &&
            <div className='bg-blue-10 rounded-[12px] py-[40px] px-[44px] lg:p-[16px] 2xl:p-[20px]'>
                {faceCareData?.map(item => {
                    return(
                        <>
                            {item.children.parentId === activeCategoryId &&
                                <>
                                    <h1 className='font-medium leading-[24px] text-[16px]'>მუდმივმოქმედი, <span className='text-raspberry-100'>35% ფასდაკლება</span> მოცემული ბრენდების ასორტიმენტზე. ფასდაკლებით სარგებლობა შესაძლებელია ყოველ დღე და ულიმიტოდ.</h1>
                                    <div className={`flex items-center gap-y-[40px] gap-x-[5px] justify-between  ${!item.children.img4 && "!justify-center !gap-x-[48px] xl:!gap-x-[36px]"} flex-wrap mt-[56px]`}>
                                    
                                        {item.children.img1 &&
                                            <img
                                                src={item.children.img1}
                                                alt=""
                                                className='w-[178px] h-[178px] 2xl:w-[144px] 2xl:h-[144px] xl:w-[110px] xl:h-[110px] lg:w-[96px] lg:h-[96px] md:w-[80px] md:h-[80px]'
                                            />
                                        }
                                        {item.children.img2 &&
                                            <img
                                                src={item.children.img2}
                                                alt=""
                                                className='w-[178px] h-[178px] 2xl:w-[144px] 2xl:h-[144px] xl:w-[110px] xl:h-[110px] lg:w-[96px] lg:h-[96px] md:w-[80px] md:h-[80px]'
                                            />
                                        }
                                        {item.children.img3 &&
                                            <img
                                                src={item.children.img3}
                                                alt=""
                                                className='w-[178px] h-[178px] 2xl:w-[144px] 2xl:h-[144px] xl:w-[110px] xl:h-[110px] lg:w-[96px] lg:h-[96px] md:w-[80px] md:h-[80px]'
                                            />
                                        }
                                        {item.children.img4 &&
                                            <img
                                                src={item.children.img4}
                                                alt=""
                                                className='w-[178px] h-[178px] 2xl:w-[144px] 2xl:h-[144px] xl:w-[110px] xl:h-[110px] lg:w-[96px] lg:h-[96px] md:w-[80px] md:h-[80px]'
                                            />
                                        }
                                        {item.children.img5 &&
                                            <img
                                                src={item.children.img5}
                                                alt=""
                                                className='w-[178px] h-[178px] 2xl:w-[144px] 2xl:h-[144px] xl:w-[110px] xl:h-[110px] lg:w-[96px] lg:h-[96px] md:w-[80px] md:h-[80px]'
                                            />
                                        }
                                    
                                    </div>
                                </>
                            }
                        </>
                    )
                })}
            </div>
        }
    </div>
  )
}

export default FaceCareSection